// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__yjYSu","rootNoMargin":"styles_rootNoMargin__3fsQp"};